import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=3c0c7c86&lang=pug&"
import script from "./legend.vue?vue&type=script&setup=true&lang=js&"
export * from "./legend.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./legend.vue?vue&type=style&index=0&id=3c0c7c86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports